module.exports = __webpack_public_path__ + "static/media/five_stages_icon.ef44add0.svg";